export const configuratorProperty = {
    grade: 'grade',
    engine: 'engine',
    colour: 'colour',
    trim: 'trim',
    accessories: 'accessories',
};

export const groupType = {
    wheels: 'wheels',
};
